export const defaultPairs = [
    ["div", "÷"],
    ["pi", "π"],
    ["euler", "ℯ"],
    ["in", "∈"],
    ["notin", "∉"],
    ["ni", "∋"],
    ["nni", "∌"],
    ["circ", "∘"],
    ["sqrt", "√"],
    ["cbrt", "∛"],
    ["cap", "∩"],
    ["cup", "∪"],
    ["approx", "≈"],
    ["napprox", "≉"],
    ["ne", "≠"],
    ["equiv", "≡"],
    ["nequiv", "≢"],
    ["le", "≤"],
    ["ge", "≥"],
    ["subseteq", "⊆"],
    ["supseteq", "⊇"],
    ["nsubseteq", "⊈"],
    ["nsupseteq", "⊉"],
    ["subsetneq", "⊊"],
    ["supsetneq", "⊋"],
    ["veebar", "⊻"],
    ["lambda", "λ"],
    ["epsilon", "ϵ"],
    ["theta", "θ"],
    ["Delta", "Δ"],
    ["_0", "₀"],
    ["_1", "₁"],
    ["_2", "₂"],
    ["_3", "₃"],
    ["_4", "₄"],
    ["_5", "₅"],
    ["_6", "₆"],
    ["_7", "₇"],
    ["_8", "₈"],
    ["_9", "₉"],
    ["^0", "⁰"],
    ["^1", "¹"],
    ["^2", "²"],
    ["^3", "³"],
    ["^4", "⁴"],
    ["^5", "⁵"],
    ["^6", "⁶"],
    ["^7", "⁷"],
    ["^8", "⁸"],
    ["^9", "⁹"],
];
//# sourceMappingURL=default.js.map